import styled from 'styled-components'

export const Modal = styled.div`
  position: absolute;
  z-index: 1000;
  position: relative;
  width: min(720px, 95vw);
  height: min(684px, 95vh);
  padding: 33px 10px 23px;
  background-color: #ffffff;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  align-self: center;
  margin: auto;
  box-sizing: border-box;
  overflow: hidden;

  @media only screen and (max-width: 768px) {
    width: min(339px, 99vw);
    height: min(545px, 99vh);
    border-radius: 12px;
  }
`

export const Close = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  background: none;
  padding: 30px;
  width: 32px;
  height: 32px;
  border: none;
  cursor: pointer;
  z-index: 10;
  &:before,
  &:after {
    border-radius: 3px;
    height: 2px;
    width: 32px;
    background: #8b8b8b;
    content: '';
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    @media only screen and (max-width: 768px) {
      width: 20px;
    }
  }
  &:after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
`

export const Balance = styled.div`
  font-family: Helvetica Neue;
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  display: flex;
  & bold {
    font-weight: 500;
  }
  & img {
    width: 22px;
    height: 22px;
    margin: 0 10px;
  }
  @media only screen and (max-width: 768px) {
    font-size: 16px;
    & img {
      width: 16px;
      height: 16px;
      margin: 0 6px;
    }
  }
`

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  max-height: 267px;
  max-width: 310px;
  margin: 100px 0 40px;
  @media only screen and (max-width: 768px) {
    max-height: 166px;
    max-width: 192px;
    margin: 67px 0 37px;
  }
`

export const Text = styled.div`
  font-family: Helvetica Neue;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: center;
  max-width: 315px;
  & span {
    color: #ff5e6d;
  }
  @media only screen and (max-width: 768px) {
    font-size: 14px;
  }
`

export const ButtonsContainer = styled.div`
  margin: 30px 0 40px;
  display: flex;
  gap: 26px;
  flex-wrap: wrap;
  justify-content: center;
  @media only screen and (max-width: 768px) {
    gap: 13px;
    margin: 30px 0 18px;
  }
`

export const Button = styled.button`
  height: 44px;
  min-width: 252px;
  border-radius: 22px;
  padding: 13px 11px;
  background: ${({ isSecondary }) => (isSecondary ? '#fff' : '#ff5e6d')};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ isSecondary }) => (isSecondary ? '#ff5e6d' : '#fff')};
  border: ${({ isSecondary }) => (isSecondary ? '1px solid #ff5e6d' : '0')};
  font-family: Helvetica Neue;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0px;
  cursor: pointer;
  & img {
    width: 20px;
    height: 20px;
    margin: 0 5px;
  }
  @media only screen and (max-width: 768px) {
    font-size: 14px;
  }
`

export const Terms = styled.div`
  font-family: Helvetica Neue;
  font-size: 11px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0px;
  text-align: center;
  color: #b9b9b9;
  display: flex;
  flex-direction: column;
  & a {
    color: #000;
    text-decoration: underline;
  }
`
